import React from 'react';
import kohaImage from '../assets/images/koha_image2.png';
import { MyButton } from './ui/MyButton.js';
import BenefitsSection from './ui/BenefitsSection.js';
import { benefitsOfKoha, whychoose } from '../constant.js';
import macbookImg from '../assets/images/macbook.png';
import { useNavigate } from "react-router-dom";
import image5 from '../assets/images/image5.png';
import image6 from '../assets/images/image6.png';
import ScrollAnimation from 'react-animate-on-scroll';
import cloudImg from '../assets/images/cloud.svg';
import cloudeImg1 from '../assets/images/cloud1.svg';

const kohaCardAnimationStyles = `
@keyframes kohaCardFadeIn {
    from {
        opacity: 0;
        transform: translateY(24px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
`;


const ServicesKoha = () => {
    const navigate = useNavigate();
    return (
        <>
            <style>{kohaCardAnimationStyles}</style>
            <div className='animated_card '>
            <div className='sizedbox row g-2 gap-2 justify-content-between mt-5'>
                <div className='col-12 col-md-5'>
                    <div className="container" >
                        <div className="position-relative text-center">
                            <img
                                src={kohaImage}
                                alt="Laptop"
                                className="img-fluid"
                                style={{ maxWidth: "100%" }}
                            />
                            <div className='position-absolute' style={{ width: "40%", top: "0", marginTop: "10%", left: "-5%" }}>
                                <ScrollAnimation animateIn='fadeInLeft'
                                    animateOut='fadeOutLeft' duration="2" initiallyVisible="true">
                                    <img src={cloudeImg1} alt="Cloud 1" className="img-fluid" />
                                </ScrollAnimation>
                            </div>
                            <div className=' position-absolute' style={{ width: "30%", bottom: "0%", marginBottom: "15%", right: "20%" }}>
                                <ScrollAnimation animateIn='fadeInRight'
                                    animateOut='fadeOutRight' duration="2" initiallyVisible="true">
                                    <img
                                        src={cloudeImg1}
                                        alt="Cloud 2"
                                        className="img-fluid"
                                    />
                                </ScrollAnimation>
                            </div>

                        </div>
                    </div>
                    {/* <img src={kohaImage} alt='Koha' style={{ width: "100%", height: "auto", maxHeight: "500px" }}></img> */}
                </div>
                <div className='col-12 col-md-6'>
                    <h2 style={{ color: "var(--text-color)" }}>Hosted Koha LMS <br />
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}>On Cloud</span></h2>
                    <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px", marginBottom: "30px", marginTop: "30px" }}>
                        <span style={{ fontWeight: "700", fontSize: "22px", lineHeight: "30px" }}>"Your Reliable, Fully Managed Cloud-Based Library Management Solution"</span><br /><br />
                        At LibCloud, we offer a fully managed, cloud-based Koha solution designed to meet the diverse needs of libraries of all sizes. With our turnkey Koha packages, business associates can effortlessly provide clients with a robust library management system, allowing them to focus on driving sales. Our secure cloud hosting guarantees scalability, high performance, and reliability, so you can offer a seamless solution without the worry of technical complexities. Let LibCloud simplify the process, empowering you to focus on what matters most—growing your business. Trust LibCloud to be your partner in delivering efficient, cloud-hosted Koha solutions to libraries worldwide.</p>
                    <div className='mt-auto'>
                        <MyButton btntext="Contact Us" onClick={() => { navigate("/contact") }} />
                    </div>
                </div>
            </div>
            
              {/* Business Associate Benefits Section */}
<section
    style={{
        padding: "100px 5% 80px",
        marginTop: "50px",
        background: "linear-gradient(180deg, #F5F8FF 0%, #FFFFFF 100%)"
    }}
>
    <div className="container">

        {/* Section Heading */}
        <div
            style={{
                width: "100%",
                maxWidth: "100%",
                margin: "0 0 55px",
                padding: "0",
                textAlign: "left"
            }}
        >
            <p
                style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    letterSpacing: "1.5px",
                    color: "#3568C0",
                    marginBottom: "16px",
                    textAlign: "left"
                }}
            >
                BUILT FOR BUSINESS ASSOCIATES
            </p>

            <h2
                style={{
                    color: "var(--text-color)",
                    fontWeight: "700",
                    fontSize: "clamp(28px, 3vw, 40px)",
                    lineHeight: "1.3",
                    marginBottom: "20px",
                    textAlign: "left",
                    width: "100%"
                }}
            >
                A Ready-to-Use Koha Platform for <span
                    style={{
                        background: "var(--primary-gradient-100)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    }}
                >Your Business</span>
            </h2>

            <p
                style={{
                    fontSize: "17px",
                    lineHeight: "1.8",
                    color: "var(--text-color)",
                    marginBottom: "0",
                    textAlign: "left",
                    width: "100%",
                    maxWidth: "100%"
                }}
            >
                LibCloud offers a pre-configured, cloud-hosted Koha Library Management System that enables business associates to deliver library automation services without developing or maintaining their own software infrastructure.
            </p>
        </div>

        {/* Benefits Cards */}
        <div className="row g-4">

            {[
                {
                    title: "Simplified Deployment",
                    description:
                        "Get started with a pre-configured Koha environment, reducing the effort required to set up and launch library management services for your clients."
                },
                {
                    title: "Comprehensive Library Management",
                    description:
                        "Offer a proven, open-source Library Management System that supports essential library operations, including cataloguing, circulation, acquisitions, serials management, and reporting."
                },
                {
                    title: "Access from Anywhere",
                    description:
                        "Provide access to the hosted Koha platform through a web browser, subject to configured access permissions and internet connectivity."
                },
                {
                    title: "Flexible Service Offering",
                    description:
                        "Extend your existing portfolio with cloud-hosted Koha subscriptions and related implementation or customisation services, according to your business model and the services you are authorised to provide."
                },
                {
                    title: "Designed for Business Associates",
                    description:
                        "Build on your existing customer relationships by adding library automation to your technology portfolio through LibCloud's pre-hosted platform."
                },
                {
                    title: "Focus on Growing Your Business",
                    description:
                        "Reduce the burden of managing your own hosting infrastructure so you can focus on client relationships, service delivery, and business growth."
                }
            ].map((item, index) => (
                <div
                    className="col-12 col-md-6 col-lg-4 d-flex"
                    key={item.title}
                    style={{
                        animation: "kohaCardFadeIn 0.7s ease both",
                        animationDelay: `${index * 0.15}s`
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "280px",
                            padding: "32px 28px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            background: "#FFFFFF",
                            border: "1px solid #E5EAF5",
                            borderRadius: "16px",
                            boxShadow: "0 5px 20px rgba(30, 60, 120, 0.06)",
                            transition: "transform 0.25s ease, box-shadow 0.25s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-5px)";
                            e.currentTarget.style.boxShadow =
                                "0 12px 28px rgba(30, 60, 120, 0.12)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                                "0 5px 20px rgba(30, 60, 120, 0.06)";
                        }}
                    >

                        <h4
                            style={{
                                color: "var(--text-color)",
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "28px",
                                marginBottom: "16px",
                                minHeight: "56px",
                                display: "flex",
                                alignItems: "flex-start"
                            }}
                        >
                            {item.title}
                        </h4>

                        <p
                            style={{
                                color: "var(--text-color)",
                                fontSize: "15px",
                                lineHeight: "25px",
                                marginBottom: "0",
                                textAlign: "left"
                            }}
                        >
                            {item.description}
                        </p>
                    </div>
                </div>
            ))}

        </div>


    </div>
</section>


            <div className='d-flex justify-content-end' style={{ marginBottom: "-20%", paddingRight: "10%" }}>
                <img src={cloudImg} alt='Cloud' style={{ maxWidth: "50%", height: "auto" }}></img>
            </div>
            <div style={{ backgroundImage: "linear-gradient(0, #EBF1FD  0 50%, white 50% 100%)" }}>
                <div className="container" >
                    <div className="position-relative text-center">
                        <img
                            src={macbookImg}
                            alt="Laptop"
                            className="img-fluid"
                            style={{ maxWidth: "100%" }}
                        />
                        <div className='position-absolute' style={{ width: "25%", bottom: "0", marginBottom: "10%", left: "5%" }}>
                            <ScrollAnimation animateIn='fadeInLeft'
                                animateOut='fadeOutLeft' duration="2">
                                <img src={image5} alt="Custom OPAC Layout" className="img-fluid" />
                            </ScrollAnimation>
                        </div>
                        <div className=' position-absolute' style={{ width: "25%", bottom: "0%", marginBottom: "31%", right: "5%" }}>
                            <ScrollAnimation animateIn='fadeInRight'
                                animateOut='fadeOutRight' duration="2">
                                <img
                                    src={image6}
                                    alt="Pre-defined Reports"
                                    className="img-fluid"
                                />
                            </ScrollAnimation>
                        </div>

                    </div>
                </div>
            </div>

            </div>
        </>
    );
}

export default ServicesKoha;
